import React, { FC } from 'react';
import { Typography } from '@mui/material';

import styled from 'styled-components';
import { colors } from '../../../common/styles/colors';
import { minWidth } from '../../../common/styles/helpers';

type Props = {
  className?: string;
};

export const WelcomeBanner: FC<Props> = ({ className }) => {
  return (
    <Wrapper className={className}>
      <ContentSection>
        <Title variant="h1">Vítej ve StartupBoxu!</Title>

        <CallToAction variant="body1">
          Pomáháme proměnit podnikatelské nápady v realitu. Nech se vést v sekci
          &quot;Moje nápady&quot;, nebo rovnou využij pomoc AI Buddyho.
        </CallToAction>
      </ContentSection>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 32px;
  border-radius: 16px;
  color: ${colors.black};
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  text-align: center;

  ${minWidth.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
`;

const ContentSection = styled.div`
  flex: 1;
  max-width: 500px;
`;

const Title = styled(Typography)`
  color: ${colors.brand};
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 32px;

  ${minWidth.mobile} {
    font-size: 2.5rem;
  }
`;

const CallToAction = styled(Typography)`
  color: ${colors.brand};
  line-height: 1.6;
  font-size: 15px;
  font-weight: 400;

  ${minWidth.mobile} {
    font-size: 1rem;
  }
`;
